import { css } from 'styled-components';
import { getColor } from '../mixins/colors';
import { fontFamilyBold } from '../variables/typography';

export default css`
  .collapsible {
    border-top: 1px solid ${getColor('grey', 300)};

    &:last-child {
      border-bottom: 1px solid ${getColor('grey', 300)};
    }

    &--no-border {
      border-top: none;
      border-bottom: none;
    }

    &__toggle-wrapper {
      display: flex;
      align-items: center;

      & span {
        margin-right: 0.4rem;
      }
    }

    & > label,
    .toggle-collapsible {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 1.2rem 0;
      cursor: pointer;
      ${fontFamilyBold}

      & svg,
      & icon {
        transition: 0.2s ease-in-out;
        pointer-events: none;
        font-size: 2rem;
      }

      &[aria-expanded='true'] icon {
        transform: rotate(180deg);
      }
    }

    & .collapsed {
      visibility: hidden;
      height: 0;
    }
  }

  .ReactCollapse--collapse {
    transition: height 200ms;
  }

  .collapsible__content[aria-hidden='false'] {
    overflow: hidden;
    transition: height 0.2s ease-in-out;
  }

  .collapsible__content[aria-hidden='true'] {
    transition: height 0.2s ease-in-out;
  }
`;
